
/**
 * 设备管理
 */

// 公共方法
import { setStoreApiDate } from '../utils'

export default {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    // 添加设备
    async fetchInsertBatchDevice({ commit, getters }, params) {
      const { insertBatchDevice } = getters.getHttps
      const { data } = await insertBatchDevice(params)
      return setStoreApiDate(data, commit)
    },
    // 更改设备状态
    async fetchUpdateBatchDeviceStatus({ commit, getters }, params) {
      const { updateBatchDeviceStatus } = getters.getHttps
      const { data } = await updateBatchDeviceStatus(params)
      return setStoreApiDate(data, commit)
    },
    // 删除扫码器中的设备
    async fetchDeleteQRScannerDevice({ commit, getters }, params) {
      const { deleteQRScannerDevice } = getters.getHttps
      const { data } = await deleteQRScannerDevice(params, true)
      return setStoreApiDate(data, commit)
    },
    // 查询扫码器中的设备列表
    async fetchSelectQRScannerDeviceList({ commit, getters }, params) {
      const { selectQRScannerDeviceList } = getters.getHttps
      const { data } = await selectQRScannerDeviceList(params)
      return setStoreApiDate(data, commit)
    },
    // 查询已添加设备所属管理区域
    async fetchSelectSearchDeviceThreeLevelLinkageAreaList({ commit, getters }, params) {
      const { selectSearchDeviceThreeLevelLinkageAreaList } = getters.getHttps
      const { data } = await selectSearchDeviceThreeLevelLinkageAreaList(params)
      return setStoreApiDate(data, commit)
    },
    // 查询设备分页列表
    async fetchSelectDevicePageList({ commit, getters }, params) {
      const { selectDevicePageList } = getters.getHttps
      const { data } = await selectDevicePageList(params)
      return setStoreApiDate(data, commit)
    },
    // 获取绑定设备的经销商列表
    async fetchSelectBindingDeviceDealerUserList({ commit, getters }, params) {
      const { selectBindingDeviceDealerUserList } = getters.getHttps
      const { data } = await selectBindingDeviceDealerUserList(params)
      return setStoreApiDate(data, commit)
    },
    // 获取单台设备绑定的所有用户列表
    async fetchSelectOneDeviceBindingAllAppletUserList({ commit, getters }, params) {
      const { selectOneDeviceBindingAllAppletUserList } = getters.getHttps
      const { data } = await selectOneDeviceBindingAllAppletUserList(params)
      return setStoreApiDate(data, commit)
    },
    // 获取搜索设备经销商下拉列表
    async fetchSelectSearchDeviceComboBoxDealerUserList({ commit, getters }, params) {
      const { selectSearchDeviceComboBoxDealerUserList } = getters.getHttps
      const { data } = await selectSearchDeviceComboBoxDealerUserList(params)
      return setStoreApiDate(data, commit)
    },
    // 添加成功或者关闭弹窗后 清除扫码枪设备
    async fetchDeleteAllQRScannerDevice({ commit, getters }, params) {
      const { deleteAllQRScannerDevice } = getters.getHttps
      const { data } = await deleteAllQRScannerDevice(params,true)
      return setStoreApiDate(data, commit)
    },
    // 删除设备
    async fetchDeleteDevice({ commit, getters }, params) {
      const { deleteDevice } = getters.getHttps
      const { data } = await deleteDevice(params)
      return setStoreApiDate(data, commit)
    },
    

    /* --- 记录 */
    // 使用
    async fetchSelectDeviceUseCountRecordPageList({ commit, getters }, params) {
      const { selectDeviceUseCountRecordPageList } = getters.getHttps
      const { data } = await selectDeviceUseCountRecordPageList(params)
      return setStoreApiDate(data, commit)
    },
    // 连接
    async fetchSelectDeviceConnectionCountRecordPageList({ commit, getters }, params) {
      const { selectDeviceConnectionCountRecordPageList } = getters.getHttps
      const { data } = await selectDeviceConnectionCountRecordPageList(params)
      return setStoreApiDate(data, commit)
    },
  }
}

